var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeonCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 540,
    viewBox: "0 0 360 540",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f093fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f5576c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 540,
    fill: "url(#gn)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 380,
    width: 35,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 340,
    width: 28,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 360,
    width: 45,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 400,
    width: 30,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 370,
    width: 25,
    height: 130
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeonCity);
export default __webpack_public_path__ + "static/media/neon-city.ec4cc0148ec16ed688b54a22d3f9186d.svg";
export { ForwardRef as ReactComponent };